const reviews = [
  {
    name: 'M.K. 様',
    age: '30代・女性',
    rating: 5,
    title: '頭がスッキリして驚きました',
    body: 'ドライヘッドマッサージを受けました。施術後は本当に頭が軽くなって、長年悩んでいた肩こりまで楽になりました。個室なので周りを気にせずリラックスできました。また必ず来ます！',
    avatar: 'https://public.readdy.ai/ai/img_res/2880c7aa7b67fd8ee86ba1845deeaf5a.jpg',
  },
  {
    name: 'Y.T. 様',
    age: '40代・女性',
    rating: 5,
    title: '肌の変化を実感できました',
    body: 'フェイシャルと小顔矯正を受けました。最初は半信半疑でしたが、施術後に鏡を見てびっくり！輪郭がすっきりして、翌日もお肌がツルツルのままでした。定期的に通っています。',
    avatar: 'https://readdy.ai/api/search-image?query=friendly%20japanese%20woman%2040s%20portrait%20gentle%20smile%2C%20neat%20hair%2C%20clean%20white%20background%2C%20warm%20natural%20lighting%20professional%20photo&width=80&height=80&seq=rev002&orientation=squarish',
  },
  {
    name: 'S.N. 様',
    age: '30代・女性',
    rating: 5,
    title: 'よもぎ蒸しで冷えが改善！',
    body: 'ずっと冷え性に悩んでいて、よもぎ蒸しに初挑戦しました。ポカポカが続いて、その夜はぐっすり眠れました。先生が丁寧に説明してくれるので初めての方でも安心です。',
    avatar: 'https://readdy.ai/api/search-image?query=friendly%20japanese%20woman%2030s%20casual%20portrait%20warm%20smile%2C%20natural%20look%2C%20clean%20simple%20background%2C%20cozy%20warm%20toned%20photo&width=80&height=80&seq=rev003&orientation=squarish',
  },
  {
    name: 'R.O. 様',
    age: '20代・女性',
    rating: 5,
    title: 'むくみがすごく取れました',
    body: 'リンパマッサージを受けました。長時間のデスクワークで足がパンパンだったのですが、施術後にブーツが楽に履けて感動！先生の丁寧な施術と心地よい空間に癒されました。',
    avatar: 'https://readdy.ai/api/search-image?query=friendly%20japanese%20woman%2020s%20portrait%20big%20smile%2C%20casual%20style%2C%20white%20background%2C%20natural%20warm%20lighting%20photo&width=80&height=80&seq=rev004&orientation=squarish',
  },
  {
    name: 'A.H. 様',
    age: '50代・女性',
    rating: 5,
    title: '贅沢な時間でした',
    body: '友人に勧められて初めて来店しました。完全個室でゆっくりできるのが嬉しくて、施術の質も高くて大満足。先生が親切で、身体の状態に合わせて丁寧にケアしてくれます。',
    avatar: 'https://readdy.ai/api/search-image?query=friendly%20japanese%20woman%2050s%20portrait%20kind%20smile%2C%20elegant%20look%2C%20white%20clean%20background%2C%20warm%20lighting%20professional%20photo&width=80&height=80&seq=rev005&orientation=squarish',
  },
  {
    name: 'C.M. 様',
    age: '30代・女性',
    rating: 5,
    title: '仕事帰りに通えるのが助かります',
    body: '当日予約ができるのでとても便利です。仕事の疲れを感じた時に気軽に寄れます。ヘッドスパを定期的に受けるようになってから、慢性的な目の疲れが楽になりました。',
    avatar: 'https://readdy.ai/api/search-image?query=friendly%20japanese%20woman%2030s%20office%20look%20portrait%20warm%20smile%2C%20professional%20neat%20appearance%2C%20white%20background%2C%20natural%20soft%20lighting&width=80&height=80&seq=rev006&orientation=squarish',
  },
];

export default function Reviews() {
  return (
    <section id="reviews" className="py-28 px-8 bg-[#faf8f5]">
      <div className="max-w-6xl mx-auto">
        {/* Header */}
        <div className="text-center mb-16">
          <p
            className="text-[#6b7c5c] text-xs tracking-[0.35em] mb-3"
            style={{ fontFamily: "'Cormorant Garamond', serif" }}
          >
            Customer Reviews
          </p>
          <h2
            className="text-stone-800 text-4xl md:text-5xl font-light mb-4"
            style={{ fontFamily: "'Cormorant Garamond', serif" }}
          >
            お客様の嬉しいお声
          </h2>
          <p
            className="text-stone-400 text-sm tracking-wide"
            style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
          >
            多くのお客様にご満足いただいております
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {reviews.map((r) => (
            <div key={r.name} className="bg-white rounded-2xl p-7 flex flex-col gap-4">
              {/* Stars */}
              <div className="flex gap-1">
                {Array.from({ length: r.rating }).map((_, i) => (
                  <i key={i} className="ri-star-fill text-amber-400 text-sm" />
                ))}
              </div>
              <h4
                className="text-stone-800 font-medium text-sm"
                style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
              >
                {r.title}
              </h4>
              <p
                className="text-stone-400 text-xs leading-relaxed flex-1"
                style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
              >
                {r.body}
              </p>
              {/* User */}
              <div className="flex items-center gap-3 pt-2 border-t border-stone-100">
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0">
                  <img src={r.avatar} alt={r.name} className="w-full h-full object-cover object-top" />
                </div>
                <div>
                  <p
                    className="text-stone-700 text-sm font-medium"
                    style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
                  >
                    {r.name}
                  </p>
                  <p
                    className="text-stone-400 text-xs"
                    style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
                  >
                    {r.age}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
